import React, { useState,useEffect } from "react";
import { useSelector } from "react-redux";
import { makeStyles, Grid, Typography, Box, Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import { grey100 } from "material-ui/styles/colors";
import { saveAs } from 'file-saver';
const useStyle = makeStyles((theme) => ({
    image: {
        margin: "1rem"
    },
    box: {
        justify: "center",
        backgroundColor: grey100,
        border: "1px dashed" + theme?.palette?.eRich?.base,
        margin: '1rem'
    },
    technicalLabel: {
        fontWeight: "bold"
    },
    inProgressLabel: {
        color: theme?.palette?.eTertiary?.base,
        fontWeight: "bold"
    },
    content: {
        margin: '2rem',
    },
    revistContent: {
        color: theme?.palette?.ePrimary?.base,
        fontWeight: "bold",
        margin: "1rem"
    }, paymentContent: {
        margin: "2rem"
    },
    paymentButton: {
        backgroundColor: theme?.palette?.ePrimary?.base,
        color: theme?.palette?.eWhite?.base,
        borderRadius: 30,
        '&:hover': {
            backgroundColor: theme?.palette?.ePrimary?.hover,
            color: theme?.palette?.eWhite?.base,
        },
    },margin:{
        [theme.breakpoints.up("md")]: {
            marginTop:"4%"
        },
    }
}))

export default function ESecurityDeposit({response,trackingCaseId}) {
    const { t: labels, ready: labelReady } = useTranslation("label-E_TRACKING_NEW_CONNECTION");
    const { t: content, ready: contentReady } = useTranslation("content-NESCO_TRACK_REQUEST")
    const { t: titlelabels, ready: titlelabelsReady } = useTranslation("label-E_TRACKING_NEW_CONNECTION");
    const trackClass = useStyle();
    let fileContentdata= response && response?.ticketAttachments?.AttachmentList ? true :false
   const [fileData,setfileData]=useState("")
   let fileDatatest;
   useEffect(()=>{
    if(fileContentdata){
    if(Array.isArray(response?.ticketAttachments?.AttachmentList)){
        let obj = response?.ticketAttachments?.AttachmentList.find(item => item?.fileName === 'DemandNote');
        obj && setfileData(obj?.fileContent)
    }else{
        setfileData(response?.ticketAttachments?.AttachmentList?.fileContent)
    }
    }else{
        setfileData("")
    }},[fileContentdata])
   const getFileName = () => {
        let fileName = trackingCaseId;
          fileName = fileName + titlelabels("E_SECURITYDEPOSIT")+".pdf"
        return fileName;
    }
    const handler=()=>{
    saveAs('data:application/pdf;base64,'+fileData, getFileName());
 }
    return (
        <>
            <Grid container justify='center' className={trackClass.margin}>
            
            <Grid container justify='center'>
                <Grid item>
                {contentReady ? <Typography variant="body2" className={trackClass.content}>
                {content("E_TRACKING_SECURITY").answer}
                </Typography> : <Skeleton/>}
                </Grid>
            </Grid>
            {fileData==="" ?
                <Grid item className={trackClass.revistContent1}>
                {labelReady ? <Typography variant="body2" >
                {labels("E_APPLICATION_2")}
                </Typography> : <Skeleton/>}
                </Grid>
            :
            <Grid container justify='center'>
                <Grid item className={trackClass.revistContent}>
                    <Button variant="outlined" onClick={handler} className={trackClass.paymentButton} >{titlelabelsReady ? titlelabels("E_DOWNLOAD_INVOICE"):""}
                    </Button>
                </Grid>
            </Grid>}
            </Grid>
        </>
    )
}